import React from 'react'
import { connect } from 'react-redux'
import { Grid } from '@material-ui/core'
import LeftMenu from './LeftMenu'
import RightMenu from './RightMenu'
import RSC from 'react-scrollbars-custom'
import General from './RightMenu/General'

export default connect(
  (state) => ({ pastFirstPage: state.view.stepper.campaign > 0 }),
  null,
)(({ campaignID, pastFirstPage }) => (
  <div style={{ height: '100%' }}>
    {pastFirstPage ? (
      <Grid style={{ height: '100%' }} container spacing={24}>
        <Grid style={{ height: '100%' }} item xs={7}>
          <LeftMenu campaignID={campaignID} />
        </Grid>
        <Grid style={{ height: '100%', padding: '12px 12px 0' }} item xs={5}>
          <RSC style={{ height: '100%' }} noScrollX>
            <RightMenu style={{ paddingRight: 5 }} />
          </RSC>
        </Grid>
      </Grid>
    ) : (
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: 35,
          border: '1px solid gray',
          padding: 20,
        }}
      >
        <General />
      </div>
    )}
  </div>
))
